<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Product Banners</h1>

    <portal to="quickActions" >
      <div>
        <inertia-link :href="route('manage.products')" class="border px-2 py-1 bg-white rounded">Back to Products</inertia-link>
        <inertia-link :href="route('manage.products.banners.create')" class="border px-2 py-1 bg-primary-500 text-white rounded">Create Banner</inertia-link>
      </div>
    </portal>

    <div class="bg-white p-3">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pt-6 pb-4">Banner</th>
          <th class="pt-6 pb-4">Published</th>
          <th class="pt-6 pb-4"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in banners" class="text-left font-bold">
          <td class="border-t text-sm p-2">
            <h3 class="text-base mb-2">{{item.title}}</h3>
            <div class="h-28 flex">
              <img :src="item.image_url" class="object-contain" alt="image" />
            </div>
            <div v-if="item.link" class="text-sm">
              {{ item.link }}
            </div>
          </td>
          <td class="border-t text-sm">
            <span v-if="item.publish">Yes</span>
            <span v-else>No</span>
          </td>
          <td class="border-t text-sm">
            <inertia-link :href="route('manage.products.banners.edit', {banner: item.id })">Edit</inertia-link>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Admin/Layout'

export default {
  metaInfo: { title: 'Manage Banners Ads' },
  layout: Layout,
  props: {
    banners: Array
  }
}
</script>
